import React from 'react'

const FirebaseContext = React.createContext(null)
export default FirebaseContext
